import { HttpContext } from '@angular/common/http';
import { inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { HTTP_PREVENT_DEFAULT_ON_ERROR_TOKEN } from '@core/http-legacy';
import { I18nService } from '@core/i18n-legacy';
import { TellentHttpApiService } from '@core/tellent-http-legacy';
import { TellentComponentsNotificationService } from '@core/tellent-util';

import { TellentSecureChangeActions } from './tellent-secure-change.actions';

export class TellentSecureChangeEffects {
  public actions$ = inject(Actions);
  public httpApi = inject(TellentHttpApiService);
  public i18nService = inject(I18nService);
  public notificationsService = inject(TellentComponentsNotificationService);

  public sendCode$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TellentSecureChangeActions.sendCode),
      switchMap(() =>
        this.sendCode().pipe(
          tap(() =>
            this.notificationsService.success(
              this.i18nService.translate('tlc.current_user.authentication_form.email_send_title'),
              this.i18nService.translate('tlc.current_user.authentication_form.email_send_message'),
            ),
          ),
          map(() => TellentSecureChangeActions.sendCodeSuccess()),
          catchError(() => of(TellentSecureChangeActions.sendCodeFail())),
        ),
      ),
    ),
  );

  public validateCode$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TellentSecureChangeActions.validateCode),
      switchMap(({ code }) =>
        this.validateCode(code).pipe(
          map(() => TellentSecureChangeActions.validateCodeSuccess({ ok: true })),
          catchError(err =>
            of(
              TellentSecureChangeActions.validateCodeFail({
                ok: false,
                error: err.error.errors[0],
              }),
            ),
          ),
        ),
      ),
    ),
  );

  private validateCode(code: string) {
    const context = new HttpContext();
    context.set(HTTP_PREVENT_DEFAULT_ON_ERROR_TOKEN, true);

    return this.httpApi.post(`/api/secure-change/${code}/validate`, null, null, {
      skipCompany: true,
      httpContext: context,
    });
  }

  private sendCode() {
    return this.httpApi.post(`/api/secure-change`, null, null, {
      skipCompany: true,
    });
  }
}
